import React from 'react'
import cx from 'classnames'
import { Svgs, Images } from '../../constants/images'
import Tooltip from 'react-simple-tooltip'
import { useTranslation } from 'react-i18next'
import { IProgram } from '../../interfaces'
import { getOpenClosed } from '../../utils'

export interface IProgramItem extends React.HTMLAttributes<HTMLDivElement> {
  program: IProgram
}

const ProgramItem = function ({ className, program, ...props }: IProgramItem) {
  const { t } = useTranslation()

  const openClosed = getOpenClosed(program, t)

  return (
    <div className={cx(className, 'ocla-program-item')} {...props}>
      <div className='ocla-program-item__content'>
        <a
          href={`/SearchAgency/${btoa(unescape(encodeURIComponent(program?.agency?.name || '')))}`}
        >
          <div className='ocla-program-item__content__agency'>{program.agency?.name}</div>
        </a>
        <a href={`/ProgramDetails/${program.securityKey}`}>
          <div className='ocla-program-item__content__title'>{program.name}</div>
          <div className='ocla-program-item__content__description'>{program.shortDescription}</div>
          <div className='ocla-program-item__content__hours'>
            {program.hoursOfOperation} •
            <div
              className={cx('ocla-program-item__content__hours__open-close', {
                green: openClosed === t('filters.open'),
              })}
            >
              {openClosed}
            </div>
          </div>
          <div className='ocla-program-item__content__neighborhood'>
            {program.region?.description}
          </div>
          <div className='ocla-program-item__content__tags'>
            {program.bedsAvailable && (
              <Tooltip content={t('filters.bedsAreAvailable')}>
                <div className='ocla-program-item__content__tags__tag'>
                  <img src={Images.bedGreen} />
                  <p>{t('filters.bedsAvailable')}</p>
                </div>
              </Tooltip>
            )}
            {program.ageTo <= 25 && (
              <Tooltip content={t('filters.youthOnlyServe')}>
                <div className='ocla-program-item__content__tags__tag'>
                  <img src={Images.youthGreen} />
                  <p>{t('filters.youthOnly')}</p>
                </div>
              </Tooltip>
            )}
            {program.ageFrom >= 50 && (
              <Tooltip content={t('filters.seniorServe')}>
                <div className='ocla-program-item__content__tags__tag'>
                  <img src={Images.seniorGreen} />
                  <p>{t('filters.seniorOnly')}</p>
                </div>
              </Tooltip>
            )}
          </div>
        </a>
      </div>
      <a href={`/ProgramDetails/${program.securityKey}`} className='ocla-program-item__arrow'>
        <img src={Svgs.arrowGreen} />
      </a>
    </div>
  )
}

export default React.memo(ProgramItem)
